export const oneToOneQueueAbi = [
  {
    inputs: [
      { internalType: 'string', name: '_name', type: 'string' },
      { internalType: 'string', name: '_symbol', type: 'string' },
      { internalType: 'address', name: '_offerAssetRecipient', type: 'address' },
      { internalType: 'address', name: '_feeRecipient', type: 'address' },
      { internalType: 'contract IFeeModule', name: '_feeModule', type: 'address' },
      { internalType: 'address', name: '_recoveryAddress', type: 'address' },
      { internalType: 'address', name: '_owner', type: 'address' },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'minimum', type: 'uint256' },
    ],
    name: 'AmountBelowMinimum',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'asset', type: 'address' }],
    name: 'AssetAlreadySupported',
    type: 'error',
  },
  { inputs: [{ internalType: 'address', name: 'asset', type: 'address' }], name: 'AssetNotSupported', type: 'error' },
  { inputs: [], name: 'ECDSAInvalidSignature', type: 'error' },
  {
    inputs: [{ internalType: 'uint256', name: 'length', type: 'uint256' }],
    name: 'ECDSAInvalidSignatureLength',
    type: 'error',
  },
  { inputs: [{ internalType: 'bytes32', name: 's', type: 'bytes32' }], name: 'ECDSAInvalidSignatureS', type: 'error' },
  { inputs: [], name: 'ERC721EnumerableForbiddenBatchMint', type: 'error' },
  {
    inputs: [
      { internalType: 'address', name: 'sender', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
      { internalType: 'address', name: 'owner', type: 'address' },
    ],
    name: 'ERC721IncorrectOwner',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'operator', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'ERC721InsufficientApproval',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'approver', type: 'address' }],
    name: 'ERC721InvalidApprover',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'operator', type: 'address' }],
    name: 'ERC721InvalidOperator',
    type: 'error',
  },
  { inputs: [{ internalType: 'address', name: 'owner', type: 'address' }], name: 'ERC721InvalidOwner', type: 'error' },
  {
    inputs: [{ internalType: 'address', name: 'receiver', type: 'address' }],
    name: 'ERC721InvalidReceiver',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'sender', type: 'address' }],
    name: 'ERC721InvalidSender',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'ERC721NonexistentToken',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'owner', type: 'address' },
      { internalType: 'uint256', name: 'index', type: 'uint256' },
    ],
    name: 'ERC721OutOfBoundsIndex',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'orderIndex', type: 'uint256' },
      { internalType: 'address', name: 'asset', type: 'address' },
      { internalType: 'uint256', name: 'required', type: 'uint256' },
      { internalType: 'uint256', name: 'available', type: 'uint256' },
    ],
    name: 'InsufficientBalanceInQueue',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'intendedDepositor', type: 'address' },
      { internalType: 'address', name: 'depositor', type: 'address' },
    ],
    name: 'InvalidDepositor',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'intendedDepositor', type: 'address' },
      { internalType: 'address', name: 'depositor', type: 'address' },
    ],
    name: 'InvalidEip2612Signature',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    name: 'InvalidOrderIndex',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'orderIndex', type: 'uint256' },
      { internalType: 'enum OneToOneQueue.OrderType', name: 'currentStatus', type: 'uint8' },
    ],
    name: 'InvalidOrderStatus',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'ordersToProcess', type: 'uint256' }],
    name: 'InvalidOrdersCount',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'ordersToProcess', type: 'uint256' },
      { internalType: 'uint256', name: 'latestOrder', type: 'uint256' },
    ],
    name: 'NotEnoughOrdersToProcess',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    name: 'OrderAlreadyProcessed',
    type: 'error',
  },
  { inputs: [], name: 'PermitFailedAndAllowanceTooLow', type: 'error' },
  {
    inputs: [
      { internalType: 'uint8', name: 'bits', type: 'uint8' },
      { internalType: 'uint256', name: 'value', type: 'uint256' },
    ],
    name: 'SafeCastOverflowedUintDowncast',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'SafeERC20FailedOperation',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'deadline', type: 'uint256' },
      { internalType: 'uint256', name: 'currentTimestamp', type: 'uint256' },
    ],
    name: 'SignatureExpired',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'bytes32', name: 'hash', type: 'bytes32' }],
    name: 'SignatureHashAlreadyUsed',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'caller', type: 'address' },
      { internalType: 'bytes', name: 'data', type: 'bytes' },
      { internalType: 'string', name: 'reasons', type: 'string' },
    ],
    name: 'Unauthorized',
    type: 'error',
  },
  { inputs: [], name: 'ZeroAddress', type: 'error' },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'approved', type: 'address' },
      { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
      { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: true, internalType: 'contract Authority', name: 'newAuthority', type: 'address' },
    ],
    name: 'AuthorityUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'contract IFeeModule', name: 'oldFeeModule', type: 'address' },
      { indexed: true, internalType: 'contract IFeeModule', name: 'newFeeModule', type: 'address' },
    ],
    name: 'FeeModuleUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'oldFeeRecipient', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newFeeRecipient', type: 'address' },
    ],
    name: 'FeeRecipientUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'asset', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'oldMinimum', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'newMinimum', type: 'uint256' },
    ],
    name: 'MinimumOrderSizeUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'asset', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'minimumOrderSize', type: 'uint256' },
    ],
    name: 'OfferAssetAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'oldRecipient', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newRecipient', type: 'address' },
    ],
    name: 'OfferAssetRecipientUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'address', name: 'asset', type: 'address' }],
    name: 'OfferAssetRemoved',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'orderIndex', type: 'uint256' },
      { indexed: true, internalType: 'address', name: 'recoveryAddress', type: 'address' },
      { indexed: true, internalType: 'address', name: 'originalReceiver', type: 'address' },
      {
        components: [
          { internalType: 'uint128', name: 'amountOffer', type: 'uint128' },
          { internalType: 'uint128', name: 'amountWant', type: 'uint128' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          { internalType: 'enum OneToOneQueue.OrderType', name: 'orderType', type: 'uint8' },
          { internalType: 'bool', name: 'didOrderFailTransfer', type: 'bool' },
        ],
        indexed: false,
        internalType: 'struct OneToOneQueue.Order',
        name: 'order',
        type: 'tuple',
      },
    ],
    name: 'OrderFailedTransfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'orderIndex', type: 'uint256' },
      {
        components: [
          { internalType: 'uint128', name: 'amountOffer', type: 'uint128' },
          { internalType: 'uint128', name: 'amountWant', type: 'uint128' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          { internalType: 'enum OneToOneQueue.OrderType', name: 'orderType', type: 'uint8' },
          { internalType: 'bool', name: 'didOrderFailTransfer', type: 'bool' },
        ],
        indexed: false,
        internalType: 'struct OneToOneQueue.Order',
        name: 'order',
        type: 'tuple',
      },
      { indexed: true, internalType: 'address', name: 'receiver', type: 'address' },
      { indexed: true, internalType: 'bool', name: 'isForceProcessed', type: 'bool' },
    ],
    name: 'OrderProcessed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'orderIndex', type: 'uint256' },
      {
        components: [
          { internalType: 'uint128', name: 'amountOffer', type: 'uint128' },
          { internalType: 'uint128', name: 'amountWant', type: 'uint128' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          { internalType: 'enum OneToOneQueue.OrderType', name: 'orderType', type: 'uint8' },
          { internalType: 'bool', name: 'didOrderFailTransfer', type: 'bool' },
        ],
        indexed: false,
        internalType: 'struct OneToOneQueue.Order',
        name: 'order',
        type: 'tuple',
      },
    ],
    name: 'OrderRefunded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'orderIndex', type: 'uint256' },
      {
        components: [
          { internalType: 'uint128', name: 'amountOffer', type: 'uint128' },
          { internalType: 'uint128', name: 'amountWant', type: 'uint128' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          { internalType: 'enum OneToOneQueue.OrderType', name: 'orderType', type: 'uint8' },
          { internalType: 'bool', name: 'didOrderFailTransfer', type: 'bool' },
        ],
        indexed: false,
        internalType: 'struct OneToOneQueue.Order',
        name: 'order',
        type: 'tuple',
      },
      { indexed: true, internalType: 'address', name: 'receiver', type: 'address' },
      { indexed: true, internalType: 'address', name: 'depositor', type: 'address' },
      { indexed: false, internalType: 'bool', name: 'isSubmittedViaSignature', type: 'bool' },
    ],
    name: 'OrderSubmitted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'startIndex', type: 'uint256' },
      { indexed: true, internalType: 'uint256', name: 'endIndex', type: 'uint256' },
    ],
    name: 'OrdersProcessedInRange',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'oldRecoveryAddress', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newRecoveryAddress', type: 'address' },
    ],
    name: 'RecoveryAddressUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'from', type: 'address' },
      { indexed: true, internalType: 'address', name: 'to', type: 'address' },
      { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'address', name: 'asset', type: 'address' }],
    name: 'WantAssetAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'address', name: 'asset', type: 'address' }],
    name: 'WantAssetRemoved',
    type: 'event',
  },
  {
    inputs: [
      { internalType: 'address', name: '_asset', type: 'address' },
      { internalType: 'uint256', name: '_minimumOrderSize', type: 'uint256' },
    ],
    name: 'addOfferAsset',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_asset', type: 'address' }],
    name: 'addWantAsset',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'to', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'authority',
    outputs: [{ internalType: 'contract Authority', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'feeModule',
    outputs: [{ internalType: 'contract IFeeModule', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'feeRecipient',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    name: 'forceProcess',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256[]', name: 'orderIndices', type: 'uint256[]' }],
    name: 'forceProcessOrders',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    name: 'forceRefund',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256[]', name: 'orderIndices', type: 'uint256[]' }],
    name: 'forceRefundOrders',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    name: 'getOrderStatus',
    outputs: [{ internalType: 'enum OneToOneQueue.OrderStatus', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'owner', type: 'address' },
      { internalType: 'address', name: 'operator', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'user', type: 'address' },
      { internalType: 'bytes', name: 'data', type: 'bytes' },
    ],
    name: 'isAuthorizedVerbose',
    outputs: [
      { internalType: 'bool', name: 'canCall', type: 'bool' },
      { internalType: 'string', name: 'reasons', type: 'string' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lastProcessedOrder',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'latestOrder',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'contract IERC20', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'address', name: 'receiver', type: 'address' },
    ],
    name: 'manageERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'minimumOrderSizePerAsset',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'offerAssetRecipient',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'ordersToProcess', type: 'uint256' }],
    name: 'processOrders',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'queue',
    outputs: [
      { internalType: 'uint128', name: 'amountOffer', type: 'uint128' },
      { internalType: 'uint128', name: 'amountWant', type: 'uint128' },
      { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
      { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
      { internalType: 'address', name: 'refundReceiver', type: 'address' },
      { internalType: 'enum OneToOneQueue.OrderType', name: 'orderType', type: 'uint8' },
      { internalType: 'bool', name: 'didOrderFailTransfer', type: 'bool' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'recoveryAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_asset', type: 'address' }],
    name: 'removeOfferAsset',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_asset', type: 'address' }],
    name: 'removeWantAsset',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'from', type: 'address' },
      { internalType: 'address', name: 'to', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'from', type: 'address' },
      { internalType: 'address', name: 'to', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
      { internalType: 'bytes', name: 'data', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'operator', type: 'address' },
      { internalType: 'bool', name: 'approved', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'contract Authority', name: 'newAuthority', type: 'address' }],
    name: 'setAuthority',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'contract IFeeModule', name: '_feeModule', type: 'address' }],
    name: 'setFeeModule',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_feeRecipient', type: 'address' }],
    name: 'setFeeRecipient',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_recoveryAddress', type: 'address' }],
    name: 'setRecoveryAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'uint256', name: 'amountOffer', type: 'uint256' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'intendedDepositor', type: 'address' },
          { internalType: 'address', name: 'receiver', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          {
            components: [
              { internalType: 'enum OneToOneQueue.ApprovalMethod', name: 'approvalMethod', type: 'uint8' },
              { internalType: 'uint8', name: 'approvalV', type: 'uint8' },
              { internalType: 'bytes32', name: 'approvalR', type: 'bytes32' },
              { internalType: 'bytes32', name: 'approvalS', type: 'bytes32' },
              { internalType: 'bool', name: 'submitWithSignature', type: 'bool' },
              { internalType: 'uint256', name: 'deadline', type: 'uint256' },
              { internalType: 'bytes', name: 'eip2612Signature', type: 'bytes' },
              { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            ],
            internalType: 'struct OneToOneQueue.SignatureParams',
            name: 'signatureParams',
            type: 'tuple',
          },
        ],
        internalType: 'struct OneToOneQueue.SubmitOrderParams',
        name: 'params',
        type: 'tuple',
      },
    ],
    name: 'submitOrder',
    outputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'uint256', name: 'amountOffer', type: 'uint256' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'intendedDepositor', type: 'address' },
          { internalType: 'address', name: 'receiver', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          {
            components: [
              { internalType: 'enum OneToOneQueue.ApprovalMethod', name: 'approvalMethod', type: 'uint8' },
              { internalType: 'uint8', name: 'approvalV', type: 'uint8' },
              { internalType: 'bytes32', name: 'approvalR', type: 'bytes32' },
              { internalType: 'bytes32', name: 'approvalS', type: 'bytes32' },
              { internalType: 'bool', name: 'submitWithSignature', type: 'bool' },
              { internalType: 'uint256', name: 'deadline', type: 'uint256' },
              { internalType: 'bytes', name: 'eip2612Signature', type: 'bytes' },
              { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            ],
            internalType: 'struct OneToOneQueue.SignatureParams',
            name: 'signatureParams',
            type: 'tuple',
          },
        ],
        internalType: 'struct OneToOneQueue.SubmitOrderParams',
        name: 'params',
        type: 'tuple',
      },
      { internalType: 'uint256', name: 'ordersToProcess', type: 'uint256' },
    ],
    name: 'submitOrderAndProcess',
    outputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'uint256', name: 'amountOffer', type: 'uint256' },
          { internalType: 'contract IERC20', name: 'offerAsset', type: 'address' },
          { internalType: 'contract IERC20', name: 'wantAsset', type: 'address' },
          { internalType: 'address', name: 'intendedDepositor', type: 'address' },
          { internalType: 'address', name: 'receiver', type: 'address' },
          { internalType: 'address', name: 'refundReceiver', type: 'address' },
          {
            components: [
              { internalType: 'enum OneToOneQueue.ApprovalMethod', name: 'approvalMethod', type: 'uint8' },
              { internalType: 'uint8', name: 'approvalV', type: 'uint8' },
              { internalType: 'bytes32', name: 'approvalR', type: 'bytes32' },
              { internalType: 'bytes32', name: 'approvalS', type: 'bytes32' },
              { internalType: 'bool', name: 'submitWithSignature', type: 'bool' },
              { internalType: 'uint256', name: 'deadline', type: 'uint256' },
              { internalType: 'bytes', name: 'eip2612Signature', type: 'bytes' },
              { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            ],
            internalType: 'struct OneToOneQueue.SignatureParams',
            name: 'signatureParams',
            type: 'tuple',
          },
        ],
        internalType: 'struct OneToOneQueue.SubmitOrderParams',
        name: 'params',
        type: 'tuple',
      },
    ],
    name: 'submitOrderAndProcessAll',
    outputs: [{ internalType: 'uint256', name: 'orderIndex', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'supportedOfferAssets',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'supportedWantAssets',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'index', type: 'uint256' }],
    name: 'tokenByIndex',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'owner', type: 'address' },
      { internalType: 'uint256', name: 'index', type: 'uint256' },
    ],
    name: 'tokenOfOwnerByIndex',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'from', type: 'address' },
      { internalType: 'address', name: 'to', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_asset', type: 'address' },
      { internalType: 'uint256', name: '_newMinimum', type: 'uint256' },
    ],
    name: 'updateAssetMinimumOrderSize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_newAddress', type: 'address' }],
    name: 'updateOfferAssetRecipient',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    name: 'usedSignatureHashes',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
